import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const percentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 2,
});
const numberFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function percentageFormat(n: number) {
  return percentFormatter.format(n / 100);
}

export function numberFormat(n: number) {
  return numberFormatter.format(n);
}

export const ORG_PREFIX = "ORG#";

/**
 * Adds the ORG# prefix to an organization ID if not already present
 * @param orgId - The organization ID to format
 * @returns The organization ID with ORG# prefix
 */
export function addOrgPrefix(orgId: string) {
  return orgId.startsWith(ORG_PREFIX) ? orgId : `${ORG_PREFIX}${orgId}`;
}

/**
 * Removes the ORG# prefix from an organization ID if present
 * @param orgId - The organization ID to format
 * @returns The organization ID without ORG# prefix
 */
export function removeOrgPrefix(orgId: string) {
  return orgId.startsWith(ORG_PREFIX) ? orgId.replace(ORG_PREFIX, "") : orgId;
}

/**
 * Converts an angle from degrees to radians.
 *
 * @param angleInDegress - The angle in degrees to convert.
 * @returns The angle in radians.
 */
export const deg2Rad = (angleInDegress: number): number => {
  return angleInDegress * (Math.PI / 180.0);
};
